import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { Controller } from "react-hook-form";
import ValidationErrorText from "./ValidationErrorText";
import { useTranslation } from "react-i18next";

const CustomInput = forwardRef(
  ({ value, onClick, disabled, placeholderText }, ref) => (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly
      disabled={disabled}
      placeholder={placeholderText}
      className="form-control"
    />
  )
);

CustomInput.displayName = "CustomInput";

const DatePickerDefault = ({
  control,
  name,
  rules,
  placeholder,
  icon: Icon,
  disabled,
  minDate,
  maxDate,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <DatepickerWrapper {...rest}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <DatePicker
              selected={value}
              onChange={onChange}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              peekNextMonth
              customInput={
                <CustomInput
                  disabled={disabled}
                  placeholderText={placeholder}
                />
              }
              minDate={minDate}
              maxDate={maxDate}
              {...(Icon && { showIcon: true, icon: <Icon /> })}
            />
            {error && <ValidationErrorText text={t(error.message)} />}
          </>
        )}
      />
    </DatepickerWrapper>
  );
};

const DatepickerWrapper = styled.div`
  width: 100%;
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker-wrapper .form-control {
    background-color: ${({ bg }) => (bg ? bg : "var(--bg)")};
    border: 1px solid var(--border);
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    color: var(--text);
    font-size: 14px;
    &::placeholder {
      color: var(--lightGrey);
    }
  }

  .react-datepicker__input-container {
    display: flex;
    align-items: center;
  }

  .react-datepicker__calendar-icon {
    width: 18px;
    height: 19px;
    padding-top: 5px;
    right: 5px;
  }

  .react-datepicker__view-calendar-icon input {
    padding: 6px 40px 5px 10px;
    body.rtl & {
      padding: 6px 40px 5px 10px;
    }
  }

  .form-control:focus {
    box-shadow: none;
    outline: none;
  }
`;

const ErrorMessage = styled.span`
  color: var(--error, red);
  font-size: 12px;
  margin-top: 4px;
  display: block;
`;

export default DatePickerDefault;
